export function DynamicText(type) {
  switch (type) {
    case 'PAGE_TITLE':
      return 'Tanya Egyetem';
    case 'PAGE_TITLE_SUB':
      return 'Az élelmiszer-önellátás és a vidéki élet egyeteme';
    case 'JOIN_BUTTON':
      return 'Csatlakozom a közösséghez!';
    case 'LOGIN_MEMBERS':
      return 'Belépés tagoknak!';
    case 'LANDING_1_TEXT1':
      return 'Ki akarod hozni a <strong>MAXIMUMOT</strong> vidéki életedből? Tervezed a vidékre költözést, de úgy érzed nincs meg hozzá a kellő tudásod?';
    case 'LANDING_1_TEXT2':
      return 'Bízd Ránk mentorálásodat, és megmutatjuk, hogy <strong>BÁRMIT</strong> képes vagy előállítani saját Magad, és családod számára! Elég hozzá egy <strong>FALUSI PORTA</strong>, vagy egy külterületi <strong>TANYA</strong>, a lehetőségeidnek csak a képzeleted szab határt!';
    default:
      return 'Alapértelmezett szöveg';
  }
}
